import script from "./PCPartsTabNoItems.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsTabNoItems.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsTabNoItems.vue?vue&type=style&index=0&id=906d71b0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-906d71b0"]])

export default __exports__